import { curry } from 'ramda'
import { locationDetailIncludes } from '../utils'

const componentDetailToLocationDetailsRule = {
  name: 'componentDetailToLocationDetails',
  rule: curry((__, component, location) => {
    if (!component.locationDetail || component.locationDetail === '')
      return true
    return locationDetailIncludes(component, location)
  }),
}

export const rules = {
  defaults: [componentDetailToLocationDetailsRule],
}
